import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

export const CardContainer = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  max-width: 496px;
  width: 100%;
  text-align: center;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`

export const LogoSection = styled.div`
  display: flex;
  justify-content: center;
  padding: 48px;
`

export const Logo = styled.img`
  height: 60px;
  width: auto;
  object-fit: contain;

  @media (max-width: 768px) {
    height: 50px;
  }
`
